module.exports = __webpack_public_path__ + "img/keyong.2334772c.png";